export interface ConfigParameters {
    location?: string;
}

export class Config {
    location: string;

    constructor({ location = 'assets/config.json' }: ConfigParameters = {}) {
        this.location = location;
    }
}
